import { render, staticRenderFns } from "./NotificationCrmLeadReminder.vue?vue&type=template&id=448daa82&lang=pug&"
import script from "./NotificationCrmLeadReminder.vue?vue&type=script&lang=js&"
export * from "./NotificationCrmLeadReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports